const styles = theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 420px))',
    justifyContent: 'center',
    gap: '10px',
    alignItems: 'start',
    color: '#595D6E',
    fontSize: '12px',
    [theme.breakpoints.down(theme.breakpoints.values.xl - 200)]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 420px))'
    },
    [theme.breakpoints.down(theme.breakpoints.values.lg + 50)]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 420px))'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 420px)'
    }
  },
  accountContainer: {
    display: 'contents',
    [theme.breakpoints.down(theme.breakpoints.values.lg + 50)]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      minWidth: 0,
      alignItems: 'center',
      width: '100%'
    }
  },
  numbersDataContainer: {
    display: 'contents',
    [theme.breakpoints.down(theme.breakpoints.values.xl - 200)]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      minWidth: 0,
      alignItems: 'center',
      width: '100%'
    }
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    minWidth: 0
  },
  selectRow: {
    display: 'flex',
    width: '750px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: '#fff',
    color: '#000',
    margin: '5px',
    fontSize: '14px',
    fontWeight: '500',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 'fit-content',
      margin: 'unset'
    }
  },
  firstRow: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  }
});

export default styles;

export const customSelectStyles = {
  option: {
    fontSize: '10px'
  },
  control: {
    borderStyle: 'hidden',
    width: '160px',
    boxShadow: 'none'
  },
  valueContainer: {
    fontSize: '14px'
  },
  indicatorSeparator: { display: 'none' }
};
